import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Typography } from "../../../../../components";
import { timeConverterMMDDYYHHMM } from "../../../../../utils/dates";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background: ${({theme}) => theme.grey[50]};
  border-radius: 8px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: ${({theme}) => `1px solid ${theme.grey[200]}`};
  
  &:last-child {
    border-bottom: none;
  }
`;

const Label = styled.div`
  font-weight: 600;
  color: ${({theme}) => theme.grey[600]};
`;

const Value = styled.div`
  color: ${({theme}) => theme.grey[900]};
`;

interface OverviewProps {
  role: any;
}

const Overview: FC<OverviewProps> = ({ role }) => {
  const [t] = useTranslation();

  if (!role) {
    return <Container>{t("LOADING")}...</Container>;
  }

  return (
    <Container>
      <Typography variant="h6">{t("ROLE_INFORMATION")}</Typography>
      <InfoBlock>
        <InfoRow>
          <Label>{t("ID")}:</Label>
          <Value>{role.id}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("NAME")}:</Label>
          <Value>{role.name}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("DISPLAY_NAME")}:</Label>
          <Value>{role.display_name}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("PUBLIC")}:</Label>
          <Value>{role.public ? t("YES") : t("NO")}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("DEFAULT")}:</Label>
          <Value>{role.default ? t("YES") : t("NO")}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("OWNER")}:</Label>
          <Value>{role.owner_display || t("NONE")}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("PARENT")}:</Label>
          <Value>{role.parent_display || t("NONE")}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("CREATED_AT")}:</Label>
          <Value>{timeConverterMMDDYYHHMM(role.created_at)}</Value>
        </InfoRow>
        <InfoRow>
          <Label>{t("UPDATED_AT")}:</Label>
          <Value>{timeConverterMMDDYYHHMM(role.updated_at)}</Value>
        </InfoRow>
      </InfoBlock>
    </Container>
  );
};

export default Overview;

